import React from 'react';
import styled from 'styled-components';


const BrandItemBlock = styled.li`
    float: left;
    width: 25%;
    padding: 12px 5px;
    color: ${props => props.color};
    border: 1px solid #ccc;
    margin-top: -1px;
    margin-left: -1px;
    font-size: 14px;
    text-align: center;
    cursor: pointer;
    background-color: ${props => props.bgColor};
`;

const BrandItem = ({ active, text, onClick, value }) => {

    const handleClick = () => {
        onClick(value);
    }

    return (
        <BrandItemBlock
            color={active ? '#111' : '#999'}
            bgColor={active ? '#ffe7ad' : 'transparent'}
            onClick={handleClick}>
            {text}
        </BrandItemBlock>
    );
};

export default BrandItem;